(ns shared.core.emoji)

(def emojis {:genie "\uD83E\uDDDE\u200D♀️"
             :mage "\uD83E\uDDD9"
             :rainbow "\uD83C\uDF08"
             :tada "\uD83C\uDF89"
             :robot "\uD83E\uDD16"
             :home "\uD83C\uDFE0"
             :bar-chart "\uD83D\uDCCA"
             :trademark "™️"
             :flag-canada "\uD83C\uDDE8\uD83C\uDDE6"
             :flag-united-kingdom "\uD83C\uDDEC\uD83C\uDDE7"
             :flag-united-states "\uD83C\uDDFA\uD83C\uDDF8"})

(defn emoji [emoji-key]
  (get emojis emoji-key))

(defn prefix-with-emoji [s emoji-key]
  (str (emoji emoji-key) " " s))

(defn suffix-with-emoji [s emoji-key]
  (str s " " (emoji emoji-key)))

(defn country-code->emoji [country-code]
  (when (not-empty country-code)
    (some-> (get {"CA" :flag-canada
                  "GB" :flag-united-kingdom
                  "US" :flag-united-states}
                 country-code)
            (emoji))))
